import { render, staticRenderFns } from "./PolicyTaskAssignmentDialog.vue?vue&type=template&id=81451cbe"
import script from "./PolicyTaskAssignmentDialog.vue?vue&type=script&lang=js"
export * from "./PolicyTaskAssignmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports